import {
    IconChipDepartment,
    IconChipMultiplePerson,
    IconDepartmentTitlePlus,
    IconPersonPlusCard
} from "../../../../../components/buttons/IconButtons";
import { permissionObj } from "../../../../../Helpers/permission";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Work shift model. Mirrors the attendance ShiftAccess / foodie Models, but the
 * first section (work shift schedules) is NOT a resource-mode catalog: it is the
 * zone + day/time schedule builder (WorkShiftAccessCard), buffered client-side in
 * create and submitted together in the combined create. Only departments and
 * custom access (employees) are resource-mode sections reusing ShiftResource.
 */

/**
 * Resource type identifiers handled by the resource-mode sections.
 * The work shift schedule section is excluded (it is not resource-mode).
 */
export const WORK_SHIFT_RESOURCE = {
    DEPARTMENTS: 'DEPARTMENTS',
    USERS: 'USERS'
}

/**
 * Backend "resourceString" selector for the assigned / not-assigned work shift
 * resource endpoints. The server uses it to pick the per-mode shape.
 */
export const WORK_SHIFT_RESOURCE_MODE = {
    [WORK_SHIFT_RESOURCE.DEPARTMENTS]: 'departments',
    [WORK_SHIFT_RESOURCE.USERS]: 'user'
}

export const MODEL_DATA = {
    id: null,
    name: '',
    isValid: function (schedules = []) {
        return this.name !== '' && schedules.length > 0;
    },
    toRegister: function (schedules, user, departments) {
        return {
            id: this.id,
            name: this.name,
            schedules: (schedules || []).map(item => ({
                dayId: item?.dayId,
                from: item?.from,
                to: item?.to,
                zoneId: item?.zoneId
            })),
            userIds: (user || []).map(item => item.userId ?? item.id),
            departmentIds: (departments || []).map(item => item.id)
        }
    }
}

export const STEPS_CREATE_WORK_SHIFT = {
    WORK_SHIFT: {
        INDEX: 0,
        TRANS: "work_shift",
    },
    CUSTOM_ACCESS: {
        INDEX: 1,
        TRANS: "custom_access",
    },
    DEPARTMENTS: {
        INDEX: 2,
        TRANS: "departments",
    },
    SUMMARY: {
        INDEX: 3,
        TRANS: "summary",
    }
}

export const STEPS_UPDATE_WORK_SHIFT = {
    WORK_SHIFT: {
        INDEX: 0,
        TRANS: "work_shift",
    },
    CUSTOM_ACCESS: {
        INDEX: 1,
        TRANS: "custom_access",
    },
    DEPARTMENTS: {
        INDEX: 2,
        TRANS: "departments",
    }
}

/**
 * Builds the inner Add/Assigned tab list for a resource-mode section.
 *
 * On create (no id) only the Add tab (key 0) is shown; on update (id present)
 * the Assigned tab (key 1) is added too.
 *
 * @param {Object} tabs - Tab config object.
 * @returns {(id: number|string|null|undefined) => Array<Object>} Resolver.
 */
const getTabsById = (tabs) => (id) => {
    const hasId = id !== null && id !== undefined;
    return Object.values(tabs)
        .filter(e => typeof e === 'object' && e.key !== undefined)
        .filter(e => hasId || e.key === 0);
};

export const WORK_CUSTOM_ACCESS_TABS = {
    ADD_EMPLOYEES: {
        key: 0,
        name: "ADD_EMPLOYEES",
        translation: "add_employees",
        icon: <IconPersonPlusCard width={24} height={24}/>,
        permission: permissionObj?.WEB_WORK_SHIFT_CREATE,
    },
    ASSIGNED_EMPLOYEES: {
        key: 1,
        name: "ASSIGNED_EMPLOYEES",
        translation: "assigned_employees",
        icon: <IconChipMultiplePerson width={24} height={24}/>,
        permission: permissionObj?.WEB_WORK_SHIFT_CREATE,
    },
    getTabsById: getTabsById({}),
}
WORK_CUSTOM_ACCESS_TABS.getTabsById = getTabsById(WORK_CUSTOM_ACCESS_TABS);

export const WORK_DEPARTMENTS_TABS = {
    ADD_DEPARTMENT: {
        key: 0,
        name: "ADD_DEPARTMENT",
        translation: "add_department",
        icon: <IconDepartmentTitlePlus width={24} height={24}/>,
        permission: permissionObj?.WEB_WORK_SHIFT_CREATE,
    },
    ASSIGNED_DEPARTMENT: {
        key: 1,
        name: "ASSIGNED_DEPARTMENT",
        translation: "assigned_department",
        icon: <IconChipDepartment width={24} height={24}/>,
        permission: permissionObj?.WEB_WORK_SHIFT_CREATE,
    },
    getTabsById: getTabsById({}),
}
WORK_DEPARTMENTS_TABS.getTabsById = getTabsById(WORK_DEPARTMENTS_TABS);
